import script from "./DicDetailDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./DicDetailDialog.vue?vue&type=script&setup=true&lang=ts"

import "./DicDetailDialog.vue?vue&type=style&index=0&id=61eb7058&scoped=true&lang=css"

import exportComponent from "K:\\VoionContaract\\voion.contaract.clients\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61eb7058"]])

export default __exports__